module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaBAMAAABbZFH9AAAAHlBMVEUAAACKjJmKjJmKjJmKjJmKjJmKjJmKjJmKjJmKjJkniZhHAAAACXRSTlMAXh27zsWSaSgtZzjpAAAAb0lEQVQY003Oqw2AUBBE0SF8NBb3KANHC5SBRuFoARTbLSE3szBuc8ReqcirDjVXXsOtNYopTtVxmaKXpihJAk2gCTSBkBEyji8lBmSE2M5PF8b7Mws30IUEuZAgiKAkgSbQBEKJLWRcvtpZv3V6AN9WLnuDgyyMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/images/country_close.png
// module id = xNnI
// module chunks = 1